<template>
    <div class="page-content grid grid__base">
        <cmp-header-panel class="page-content--header"></cmp-header-panel>

        <div class="page-content--content">
            <transition name="trs-wave-loader-fade">
                <cmp-wave-loader v-if="isLoading" facet="content"></cmp-wave-loader>
            </transition>

            <transition name="trs-placeholder-content-fade">
                <cmp-main-placeholder v-if="!isLoading"
                        :page-title="pageTitle"
                        :container="containers.main">
                </cmp-main-placeholder>
            </transition>

            <!-- <pre v-text="routeData"></pre> -->
        </div>
    </div>
</template>

<script>
    import { get } from 'lodash';
    import { mapGetters } from 'vuex';
    import routeMixin from 'framework/mixins/route';

    export default {
        mixins: [
            routeMixin,
        ],
        computed: {
            ...mapGetters(['viewport']),
            pageTitle() {
                return get(this.routeData, 'meta.title', '');
            },
        },
    };
</script>



// WEBPACK FOOTER //
// vehi-industriepfad/assets/src/js/app/framework/pages/content/index.vue?3af2af4a